import React from 'react';

import DropdownMenu from './../../miscellaneous/container/DropdownMenu';
import LogoCliente from './../../images/logoSM.png'
import VecpuLogo from './../../images/Vepcu.png' 

import './../landingStyle.css';

function LandingComponent({ children, session, menus, userMenu, hasFooter, menuSmall, noHeader, system }) {
  return (
    <div >
      <section className="container-header-g" id="header">
        <div className="header-escudo-g">
          <img src={system.logo !== '' ? system.logo : LogoCliente} alt="Alcalda de Santa Marta" className="escudo-image-g" />
        </div>
        <div className="header-eslogan-g">
            <img src={VecpuLogo} alt="Alcalda de Santa Marta" className="eslogan-image-g" />
        </div>
        <div className="menu-header hide-1280">
          {menus.map((val, i) => {
            return (
              <DropdownMenu metaData={val} key={'menu-drop-' + i} />
            )
          })}
        </div>
        <div className="hide-1280">
          <DropdownMenu metaData={userMenu} key={'menu-user'} />
        </div>
        <div className="show-1280">
          <DropdownMenu metaData={menuSmall} key={'menu-small'} />
        </div>
      </section >
      <div className={"content-budy " + (hasFooter ? 'footer' : '')}>
        {children}
      </div>
    </div >
  )
}

export default LandingComponent;